var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('K2Button',{on:{"onclick":_vm.downloadPDF}},[_vm._v("Download")]),_c('div',{ref:"printcontent",staticClass:"printMe",attrs:{"id":"printMe"}},[_c('ActivityPreviewforPrint',{attrs:{"printPreview":_vm.printPreview}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }